import React from "react";
import {useTranslation} from "react-i18next";
import OperatorInviteModal from "../OperatorInviteModal";
import {initials, avatarColorFor} from "../../helpers/avatar";
import {Container, Header, Title, Count, InviteBtn, Search, SearchInput, Body, Item, Avatar, Info, Name, Email, Meta, Badge, State} from "./styles";

const activity = (op, t) => {
    if (op.status === "pending") return t("words.activity_pending");
    if (!op.last_active_at) return "";
    const m = Math.floor((Date.now() - new Date(op.last_active_at).getTime()) / 60000);
    if (m < 1) return t("words.activity_now");
    if (m < 60) return `${m}m`;
    const h = Math.floor(m / 60);
    return h < 24 ? `${h}h` : `${Math.floor(h / 24)}d`;
};

const OperatorSidebar = ({operators = [], owner, selectedId, onSelect, campaignId, onInvited, loading, canInvite = true}) => {
    const {t} = useTranslation();
    const [inviteOpen, setInviteOpen] = React.useState(false);
    const [q, setQ] = React.useState("");

    const filtered = operators.filter((o) => {
        const s = q.trim().toLowerCase();
        return !s || (o.full_name || "").toLowerCase().includes(s) || (o.email || "").toLowerCase().includes(s);
    });
    const rows = owner ? [owner, ...filtered] : filtered;

    return (
        <Container>
            <Header>
                <Title>{t("words.operator")} <Count>· {operators.length}</Count></Title>
                {canInvite && <InviteBtn type="button" onClick={() => setInviteOpen(true)}>+ {t("words.invite")}</InviteBtn>}
            </Header>
            <Search>
                <SearchInput placeholder={t("words.search")} value={q} onChange={(e) => setQ(e.target.value)}/>
            </Search>
            <Body>
                {loading ? <State>{t("words.loading")}</State> : rows.map((o) => (
                    <Item key={o.key} $active={o.key === selectedId} onClick={() => onSelect(o.key)}>
                        <Avatar $color={o.synthetic ? "#F59E0B" : avatarColorFor(o.email || o.id)}>{initials(o.full_name)}</Avatar>
                        <Info>
                            <Name>{o.full_name}</Name>
                            {o.email ? <Email>{o.email}</Email> : null}
                            <Meta>
                                <Badge $role={o.role}>{t(`words.role_${o.role}`)}</Badge>
                                {!o.synthetic ? <span>· {activity(o, t)}</span> : null}
                            </Meta>
                        </Info>
                    </Item>
                ))}
            </Body>
            <OperatorInviteModal open={inviteOpen} campaignId={campaignId}
                onCancel={() => setInviteOpen(false)}
                onDone={() => { if (onInvited) onInvited(); }}/>
        </Container>
    );
};

export default OperatorSidebar;
